import { computed, ref } from 'vue'
import useAgent from '~/composables/useAgent'
import {
  DOCUMENT_TITLE_BRAND,
  buildDocumentTitle,
  firstRouteParam,
  formatAgentDisplayName,
  resolveDocumentTitleI18nKey,
} from '~/utils/documentTitle'

const titleDetail = ref<string | null>(null)

export function setDocumentTitleDetail(detail: string | null) {
  const trimmed = detail?.trim() ?? ''
  titleDetail.value = trimmed || null
}

export function useAppDocumentTitle() {
  const route = useRoute()
  const { t, locale } = useI18n()
  const { agents } = useAgent()

  const title = computed(() => {
    void locale.value

    const agentId = firstRouteParam(route.params.agentid)
    const agentMatch = agentId
      ? agents.value?.find(agent => agent.id === agentId)
      : undefined
    const agentLabel = agentMatch ? formatAgentDisplayName(agentMatch) : ''

    const campaignId = firstRouteParam(route.params.campaignId)
    const campaignLabel = campaignId ? (titleDetail.value ?? '') : ''

    const i18nKey = resolveDocumentTitleI18nKey(
      route.name,
      route.path,
      route.matched.map(record => record.name),
    )
    const pageLabel = i18nKey ? t(i18nKey) : ''

    return buildDocumentTitle([
      DOCUMENT_TITLE_BRAND,
      agentLabel || campaignLabel || pageLabel,
    ])
  })

  useHead({ title })
}
